@file:OptIn(InternalResourceApi::class)

package fr.frux.core.ads.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.core.ads.resources/"

@delegate:ResourceContentHash(380_909_173)
internal val Res.string.ads_intro_body: StringResource by lazy {
      StringResource("string:ads_intro_body", "ads_intro_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 370),
      ))
    }

@delegate:ResourceContentHash(-1_438_906_913)
internal val Res.string.ads_intro_continue: StringResource by lazy {
      StringResource("string:ads_intro_continue", "ads_intro_continue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 381, 38),
      ))
    }

@delegate:ResourceContentHash(-1_169_020_988)
internal val Res.string.ads_intro_learn_more: StringResource by lazy {
      StringResource("string:ads_intro_learn_more", "ads_intro_learn_more", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 585, 48),
      ))
    }

@delegate:ResourceContentHash(-903_772_572)
internal val Res.string.ads_intro_learn_more_description: StringResource by lazy {
      StringResource("string:ads_intro_learn_more_description", "ads_intro_learn_more_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 420, 164),
      ))
    }

@delegate:ResourceContentHash(-160_057_501)
internal val Res.string.ads_intro_title: StringResource by lazy {
      StringResource("string:ads_intro_title", "ads_intro_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 634, 51),
      ))
    }

@delegate:ResourceContentHash(-654_004_478)
internal val Res.string.ads_label: StringResource by lazy {
      StringResource("string:ads_label", "ads_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 686, 29),
      ))
    }

@delegate:ResourceContentHash(-113_729_805)
internal val Res.string.ads_rewarded_granted: StringResource by lazy {
      StringResource("string:ads_rewarded_granted", "ads_rewarded_granted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 716, 60),
      ))
    }

@delegate:ResourceContentHash(910_181_553)
internal val Res.string.ads_rewarded_loading: StringResource by lazy {
      StringResource("string:ads_rewarded_loading", "ads_rewarded_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 777, 64),
      ))
    }

@delegate:ResourceContentHash(1_523_433_647)
internal val Res.string.ads_rewarded_offer_link: StringResource by lazy {
      StringResource("string:ads_rewarded_offer_link", "ads_rewarded_offer_link", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 842, 83),
      ))
    }

@delegate:ResourceContentHash(-623_268_396)
internal val Res.string.ads_rewarded_pending: StringResource by lazy {
      StringResource("string:ads_rewarded_pending", "ads_rewarded_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 926, 104),
      ))
    }

@delegate:ResourceContentHash(-1_323_551_168)
internal val Res.string.ads_rewarded_unavailable: StringResource by lazy {
      StringResource("string:ads_rewarded_unavailable", "ads_rewarded_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1031, 88),
      ))
    }

@delegate:ResourceContentHash(-1_963_355_632)
internal val Res.string.ads_rewarded_validating: StringResource by lazy {
      StringResource("string:ads_rewarded_validating", "ads_rewarded_validating", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1120, 79),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("ads_intro_body", Res.string.ads_intro_body)
  map.put("ads_intro_continue", Res.string.ads_intro_continue)
  map.put("ads_intro_learn_more", Res.string.ads_intro_learn_more)
  map.put("ads_intro_learn_more_description", Res.string.ads_intro_learn_more_description)
  map.put("ads_intro_title", Res.string.ads_intro_title)
  map.put("ads_label", Res.string.ads_label)
  map.put("ads_rewarded_granted", Res.string.ads_rewarded_granted)
  map.put("ads_rewarded_loading", Res.string.ads_rewarded_loading)
  map.put("ads_rewarded_offer_link", Res.string.ads_rewarded_offer_link)
  map.put("ads_rewarded_pending", Res.string.ads_rewarded_pending)
  map.put("ads_rewarded_unavailable", Res.string.ads_rewarded_unavailable)
  map.put("ads_rewarded_validating", Res.string.ads_rewarded_validating)
}
